<template>
  <div v-if="show" class="company-switcher">
    <v-select
      v-if="expanded"
      :model-value="selectedId"
      :items="companies"
      item-title="name"
      item-value="id"
      density="compact"
      variant="solo-filled"
      flat
      hide-details
      prepend-inner-icon="mdi-domain"
      class="company-switcher__select"
      @update:model-value="onChange" />

    <v-tooltip v-else text="Switch company" location="right">
      <template #activator="{ props: tooltipProps }">
        <v-menu location="right">
          <template #activator="{ props: menuProps }">
            <button type="button" class="company-switcher__rail" v-bind="{ ...tooltipProps, ...menuProps }">
              <v-icon icon="mdi-domain" size="20" />
            </button>
          </template>
          <v-list density="compact" class="company-switcher__menu">
            <v-list-item
              v-for="company in companies"
              :key="company.id"
              :title="company.name"
              :active="company.id === selectedId"
              @click="onChange(company.id)" />
          </v-list>
        </v-menu>
      </template>
    </v-tooltip>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useAuthStore } from "@/stores";
import activeCompanyService from "@/services/activeCompanyService";

defineProps({
  expanded: { type: Boolean, default: true },
});

const authStore = useAuthStore();
const companies = ref([]);
const activeId = ref(null);
const homeId = ref(null);

const show = computed(() => companies.value.length > 1);

const selectedId = computed(() => {
  const stored = authStore.activeCompanyId;
  if (stored != null) return Number(stored);
  return activeId.value ?? homeId.value;
});

async function load() {
  try {
    const data = await activeCompanyService.getOptions();
    companies.value = data.companies || [];
    activeId.value = data.activeCompanyId ?? null;
    homeId.value = data.homeCompanyId ?? null;
  } catch {
    companies.value = [];
  }
}

function onChange(id) {
  if (id === selectedId.value) return;
  authStore.setActiveCompany(id);
  window.location.reload();
}

onMounted(load);
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.company-switcher {
  padding: 8px 12px 0;
}

.company-switcher__select {
  font-family: $lh_font_family_dm_sans;
  font-size: 13px;

  :deep(.v-field) {
    background: rgba(white, 0.08);
    color: #ffffff;
    border-radius: 8px;
  }
  :deep(.v-field__input),
  :deep(.v-select__selection-text),
  :deep(.v-field__prepend-inner .v-icon),
  :deep(.v-field__append-inner .v-icon::before) {
    color: #ffffff !important;
  }
}

.company-switcher__rail {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  border: none;
  background: transparent;
  color: $lh_sidebar_text;
  cursor: pointer;
  border-radius: 8px;
  transition: color $lh_transition_fast, background-color $lh_transition_fast;

  &:hover {
    color: $lh_sidebar_text_active;
    background: $lh_sidebar_bg_hover;
  }
}
</style>
